import { Block, Element } from 'react-bulma-components';
import React, { useEffect, useState } from 'react';

import classnames from 'classnames';

const Image = ({
  fallback = `/no_image-200x200.png`,
  src,
  bg,
  ...props
}) => {
  const [state, setState] = useState({ src });
  useEffect(() => {
    if(!src){
      src = fallback
    }
    setState({ src: src.trim() });
  }, [src]);
  let bgColor = '';
  switch(bg){
    case 'o':
      bgColor = '#ff8000';
      break;
    case 'w':
      bgColor = '#ffffff';
      break;
  };

  return (
   <figure style={{textAlign: 'left', marginTop: 10, marginBottom: 10}}>
      <img
        onError={(err) => {
          return state.src !== fallback && setState({ src: fallback });
        }}
        src={`${process.env.REACT_APP_API_URL}/media${state.src}`}
        style={{borderRadius: 10, backgroundColor: bgColor}}
      />
      <figcaption>{props.children}</figcaption>
      </figure>
  );
};

export default Image;